import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function createWarehouseLocation(payload) {
  const { data: raw } = await request.post('/system/warehouse-location', keysToSnake(payload));
  return parseVer4DetailResponse(raw);
}
